module.exports = __webpack_public_path__ + "static/media/auto.a0467d33.svg";